import {CheckCircleIcon} from "@chakra-ui/icons";
import {Container, Flex, HStack, IconButton, Image, Text} from "@chakra-ui/react";
import React from "react";
import {IoHome} from "react-icons/io5";
import {useNavigate} from "react-router-dom";

import AutomatedTestCard from "../../shared/components/AutomatedTestCard";
import SATSurveyCard from "../../shared/components/SATSurveyCard";
import TestCard from "../../shared/components/TestCard";
import {useAuthentication} from "../../shared/hooks/AuthenticationProvider";
import {disableBlurProtection} from "../../shared/hooks/BlurProtection";
import {useFont} from "../../shared/hooks/FontProvider";
import {useTheme} from "../../shared/hooks/ThemeProvider";
import {Paths, SkillType} from "../../shared/model/Constants";
import {enableKeyCommands} from "../../shared/Utils";

const TestEnd = (props:{
  skillType: SkillType;
  timerStopped: boolean;
}) => {
  const theme = useTheme().theme;
  const font = useFont().font;
  const navigate = useNavigate();
  const authentication = useAuthentication();

  enableKeyCommands();
  disableBlurProtection();

  /*
  const params = useParams<{
    publicId: string;
    candidateToken: string;
  }>();

  const publicId = params.publicId || "";
  const candidateToken = params.candidateToken || "";

  const abilityQuery = useQuery(publicKeys.result(), () =>
      getAbility(publicId, candidateToken).then(extractData)
  );
  */
  const testType = props.skillType.charAt(0).toUpperCase() + props.skillType.slice(1).toLowerCase();
  const message = props.timerStopped ?
    "Time is up. The "+ testType +" Test has ended." :
    "Thank you for completing the "+ testType +" Test.";

  const institution = authentication.currentUserQuery?.data?.data?.institution !== null ?
    authentication.currentUserQuery?.data?.data.institution : "";
  const fromTweetalig = (institution && institution.trim().toLowerCase().includes("tweetalig"));

  /*
  if (abilityQuery.isError) {
    return <Navigate to={Paths.ERROR} />;
  }  else if (!abilityQuery.data) {
    return (
        <Center height="200px">
          <Spinner />
        </Center>
    );
  } else*/
  return (
  <Container maxW="max">
    <Flex justify="center" align="space-between">
      <Image
        src="/images/img-3425cf4b3e12dac41593dd47d363aecf0cbb0e59.png"
        maxH="lg"/>
      <Flex justify="center" flexDirection="column" alignItems="center" paddingX={10} width="max">
        <CheckCircleIcon boxSize="3rem" color="green" />
        <Text fontWeight={font.weight} fontSize={font.endMsg}
              width="max" paddingBottom={10}> {message}</Text>

        <HStack spacing={10}>
          {!fromTweetalig &&
            <IconButton
              aria-label="Home"
              icon={<IoHome size={font.iconButton}/>}
              onClick={()=>navigate(Paths.HOME)}
              colorScheme={theme.COLOR_SCHEME}
              boxSize={font.iconButtonBox}
            />
          }
          <SATSurveyCard />
          {props.skillType !== SkillType.READING &&
            (!fromTweetalig) &&
            <TestCard name="Reading Test"
                    description="Examen de Lectura"
                    skillType={SkillType.READING}
                    compact={true}
          />}
          {props.skillType !== SkillType.LISTENING &&
            (!fromTweetalig || props.skillType === SkillType.READING) &&
            <TestCard name="Listening Test"
                     description="Examen de Escucha"
                     skillType={SkillType.LISTENING}
                     compact={true}
          />}
          {props.skillType !== SkillType.SPEAKING &&
            (!fromTweetalig || props.skillType === SkillType.LISTENING) &&
            <TestCard name="Speaking Test"
                     description="Examen Oral"
                     skillType={SkillType.SPEAKING}
                     compact={true}
          />}
          {props.skillType !== SkillType.WRITING &&
            <TestCard name="Writing Test"
                     description="Examen Escrito"
                     skillType={SkillType.WRITING}
                     compact={true}
          />}
          {(!fromTweetalig || props.skillType === SkillType.LISTENING)  &&
            <AutomatedTestCard name="Speaking Test"
                           description="Examen Oral"
                           skillType={SkillType.SPEAKING}
                           compact={true}
          />}
          {(!fromTweetalig || props.skillType === SkillType.SPEAKING)  &&
            <AutomatedTestCard name="Writing Test"
                           description="Examen Escrito"
                           skillType={SkillType.WRITING}
                           compact={true}
          />}
        </HStack >
      </Flex>
    </Flex>
  </Container>
  );
};

export default TestEnd;
